import { getTrainingRoomsByClub, homepageadmin } from "../components/funtionsBD/Mainservice";
import { fetchSmartProfile } from "../components/funtionsBD/digipingSmartService";
import { openDigitalTwin } from "../components/HomeDailyFocus";
import { isClubScforhIncomplete } from "../constants/scforhClubHealth";

function isAutoGroup(g) {
  return (
    (g?.groupDetails?.gr_traning_session_type || g?.gr_traning_session_type) ===
    "auto"
  );
}

function groupId(g) {
  return g?.groupDetails?.gr_id || g?.gr_id || null;
}

/**
 * Club still needs Digiping quick setup when it has no hall or no real training group.
 */
export async function clubNeedsQuickSetup({ clubId, groups } = {}) {
  if (!clubId) {
    return { needed: false, hasRooms: false, hasGroups: false };
  }

  let groupList = groups;
  if (!Array.isArray(groupList)) {
    try {
      const res = await homepageadmin({
        // homePage: 1 = club admin groups, 2 = coach (see mapHomeRoleToUserType)
        user_type: 1,
        club_id: clubId,
        home_role: "admin",
      });
      groupList = res?.data?.data?.groupList || [];
    } catch {
      groupList = [];
    }
  }

  const realGroups = groupList.filter((g) => groupId(g) && !isAutoGroup(g));

  let rooms = [];
  try {
    const res = await getTrainingRoomsByClub(clubId);
    rooms = res?.data?.data || [];
  } catch {
    rooms = [];
  }

  const hasRooms = Array.isArray(rooms) && rooms.length > 0;
  const hasGroups = realGroups.length > 0;
  return { needed: !hasRooms || !hasGroups, hasRooms, hasGroups };
}

export function openClubSetupTwin({ seedMessage, seedKey, seedParams } = {}) {
  openDigitalTwin({
    home_role: "admin",
    seedMessage: seedMessage || "",
    seedVisible: false,
    profilingIntro: "clubSetup",
    seedKey: seedKey || "digipingClubSetupHomeSeed",
    seedParams: seedParams || null,
  });
}

export function openClubScforhTwin({ seedMessage, seedKey, seedParams } = {}) {
  openDigitalTwin({
    home_role: "admin",
    seedMessage: seedMessage || "",
    seedVisible: false,
    profilingIntro: "clubScforh",
    seedKey: seedKey || "digipingClubScforhHomeSeed",
    seedParams: seedParams || null,
  });
}

function sessionFlag(key) {
  try {
    return sessionStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function markSessionFlag(key) {
  try {
    sessionStorage.setItem(key, "1");
  } catch {
    /* ignore */
  }
}

/**
 * After login, club admins land on Club (not Home). Open DigiPing for
 * hall/groups setup first, then SCforH SMART if still incomplete.
 * `lang` must be the user's app language (not club-country default).
 */
export async function maybeAutoPromptAdminDigiping({
  userId,
  clubId,
  t,
  lang,
  groups,
} = {}) {
  if (!userId || !clubId || typeof t !== "function") return { opened: null };

  const setupKey = `digiping:autoPrompt:clubSetup:${userId}`;
  const scforhKey = `digiping:autoPrompt:clubScforh:${userId}`;
  const appLang = lang || "en";

  const status = await clubNeedsQuickSetup({ clubId, groups });
  const smart = await fetchSmartProfile(null, appLang);
  const clubPlan = smart?.clubPlan || {};
  const needsPeerValidate = Boolean(clubPlan.blindValidate);
  const scforhIncomplete = isClubScforhIncomplete(smart?.status);

  if (status.needed) {
    if (sessionFlag(setupKey)) return { opened: null };
    markSessionFlag(setupKey);
    const seedParams = {
      rooms: status.hasRooms ? "yes" : "none",
      groups: status.hasGroups ? "yes" : "none",
    };
    openClubSetupTwin({
      seedMessage: t("digipingClubSetupHomeSeed", {
        ...seedParams,
        lng: appLang,
      }),
      seedKey: "digipingClubSetupHomeSeed",
      seedParams,
    });
    return { opened: "clubSetup" };
  }

  if (sessionFlag(scforhKey)) return { opened: null };
  if (!needsPeerValidate && !scforhIncomplete) return { opened: null };
  markSessionFlag(scforhKey);
  const scforhSeedKey = needsPeerValidate
    ? "digipingClubScforhValidateSeed"
    : "digipingClubScforhHomeSeed";
  const seedParams = {
    groups: status.hasGroups ? "yes" : "none",
  };
  openClubScforhTwin({
    seedMessage: t(scforhSeedKey, {
      ...seedParams,
      lng: appLang,
    }),
    seedKey: scforhSeedKey,
    seedParams,
  });
  return { opened: needsPeerValidate ? "clubScforhValidate" : "clubScforh" };
}
